<template>
  <div>
    <h1 class="text-xl">设置</h1>
    <hr class="my-4">

    <p class="mb-4">点击标题展开设置项：</p>
    <div id="settings-accordion" class="ui styled accordion">
      <div class="title">
        <i class="dropdown icon"></i>
        修改昵称
      </div>
      <div class="content">
        <div class="ui action input">
          <input name="display_name" type="text" maxlength="32" v-model="display_name" id="display_name"/>
          <button class="ui teal button" @click="change_display_name">保存</button>
        </div>
      </div>
      <div class="title">
        <i class="dropdown icon"></i>
        修改密码
      </div>
      <div class="content">
        <div class="ui form">
          <div class="field">
            <label>当前密码</label>
            <input id="cur_pass" name="cur_pass" v-model="cur_pass" type="password"/>
          </div>
          <div class="field">
            <label>新密码</label>
            <PasswordInput ref="newPass" v-model="new_pass"/>
          </div>
          <div class="field">
            <label for="new_pass">重复密码</label>
            <input id="new_pass_repeat" name="new_pass_repeat" v-model="new_pass_repeat" type="password"/>
          </div>
          <div class="field">
            <label for="new_pass">短信验证码</label>
            <input id="sms_code" name="sms_code" type="text" v-model="sms_code"/>
          </div>
          <button :disabled="sms_send_cooldown > 0" @click="change_password_send_sms" class="ui purple button">
            发送验证码
            <span v-if="sms_send_cooldown > 0">({{ sms_send_cooldown }})</span>
          </button>
          <button @click="change_password" class="ui teal button">提交</button>
        </div>
      </div>
      <div v-if="false" class="title" @click="load_activities">
        <i class="dropdown icon"></i>
        已登录设备管理
      </div>
      <div v-if="false" class="content">
        <Placeholder v-if="!activities" />
        <div v-else v-for="(a, index) in activities" :key="a.token" class="ui segment">
          <p class="text-lg">
          设备 #{{ index + 1 }}
          </p>
          <div class="mt-4">
            <p>
            最近登录位置：
            <strong>
              {{ a.last_location }}
              ({{ format_time(a.last_seen) }})
            </strong>
            </p>
            <p>
            首次登录位置：
            <strong>
              {{ a.first_location }}
              ({{ format_time(a.first_seen) }})
            </strong>
            </p>
            <div class="mt-4">
              <button v-if="a.token != client.token" class="ui yellow button" @click="revoke_token(a.token)">登出</button>
              <div class="ui message" v-else>
                当前登录
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PasswordInput from '../components/password-input.vue'
import Placeholder from '../components/placeholder.vue'

export default {
  name: 'Settings',
  props: [],
  components: {
    PasswordInput,
    Placeholder,
  },
  data: function () {
    return {
      display_name: "",
      cur_pass: "",
      new_pass: "",
      new_pass_repeat: "",
      sms_code: "",
      sms_send_cooldown: 0,
      activities: null,
    };
  },
  computed: {
  },
  methods: {
    revoke_token(token) {
      this.client.revoke_token(token).then(() => {
        this.show_success("登出成功");
        this.activities = null;
        this.load_activities();
      }).catch(e => {
        this.show_error("登出失败：" + e.message);
      });
    },
    load_activities() {
      if (this.activities) return;
      this.client.fetch_activities().then(r => {
        this.activities = r;
      });
    },
    alert_class(st) {
      return st.error ? ["alert-danger"] : ["alert-success"];
    },
    async change_display_name() {
      this.$gtag.event('change-display-name', {
        event_category: 'user-action',
      });
      if (this.display_name && this.display_name != this.client.display_name) {
        if (this.display_name.length > 20) {
          this.show_errro("名称过长（最多20个字符）");
          return;
        }
        await this.client.set_display_name(this.display_name);
        this.show_success("昵称已修改！");
      }
    },
    change_password_send_sms() {
      if (!this.cur_pass.length) {
        this.show_error("请输入当前密码");
        return;
      }
      if (!this.new_pass.length) {
        this.show_error("请输入新密码");
        return;
      }
      if (this.new_pass.length < 7) {
        this.show_error("新密码太短");
        return;
      }
      if (this.new_pass != this.new_pass_repeat) {
        this.show_error("两次输入不一致");
        return;
      }
      this.$gtag.event('change-password-send-sms', {
        event_category: 'user-action',
      });
      this.client.reset_password_request_sms().then(() => {
        this.show_success("短信已发送");
        this.sms_send_cooldown = 60;
        var si = setInterval(() => {
          if (--this.sms_send_cooldown == 0) {
            clearInterval(si);
          }
        }, 1000);
      }).catch(e => {
        this.show_error(e.statusText);
      });
    },
    change_password() {
      this.$gtag.event('change-password', {
        event_category: 'user-action',
      });
      if (this.cur_pass.length == 0) {
        this.show_error("当前密码不匹配");
        return;
      }
      if (this.new_pass.length == 0) {
        this.show_error("请输入新密码");
        return;
      }
      if (this.new_pass.length < 7) {
        this.show_error("密码太短");
        return;
      }
      if (this.new_pass_repeat != this.new_pass) {
        this.show_error("两次输入不一致");
        return;
      }
      if (this.sms_code.length == 0) {
        this.show_error("请先输入短信验证码");
        return;
      }
      this.client.reset_password_complete("", this.new_pass, this.cur_pass, this.sms_code).then(() => {
        this.show_success("密码修改成功！");
        this.$gtag.event('change-password-succeeded', {
          event_category: 'general',
        });
        this.cur_pass = '';
        this.new_pass = '';
        this.$refs.newPass.reset();
        this.new_pass_repeat = '';
        this.sms_code = '';
      }).catch(e => {
        var msg = e.response.data;
        if (!msg) {
          msg = "密码修改失败";
        }
        this.show_error(msg);
      });
    },
  },
  async mounted() {
    this.$("#settings-accordion").accordion();
    await this.client.fetch_userinfo();
    this.display_name = this.client.display_name;
  },
}
</script>

<style scoped>
</style>
